import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

// Non-cached SSR provides the token via Redux props; cached pages fill in from
// the meta tag, and edge-cached pages omit even that, so fetch from /api/csrf.
const AuthToken = () => {
  const reduxToken = useSelector(({ auth }) => auth.csrfToken) || ''
  const [token, setToken] = useState(reduxToken)

  useEffect(() => {
    if (token) return undefined
    const meta = document.querySelector('meta[name=csrf-token]')
    const value = meta && meta.getAttribute('content')
    if (value) {
      setToken(value)
      return undefined
    }
    let cancelled = false
    fetch('/api/csrf', { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (!cancelled && data && data.csrfToken) setToken(data.csrfToken)
      })
      .catch(() => {})
    return () => {
      cancelled = true
    }
  }, [])

  return <input type="hidden" name="authenticity_token" value={token} />
}

export default AuthToken
